'use client';

import NumberField from '@koda/koda-components/molecules/NumberField';
import { useTranslations } from 'next-intl';
import { ReactElement } from 'react';
import { LicenseTypes } from '../../../types/licenses';
import { useLicenseBusiness } from '../hooks/useLicenseBusiness';
import {
  createMusicOnPhoneLinesDefaults,
  MUSIC_ON_PHONE_LINES_CONTENT_PATH,
  musicOnPhoneLinesSchema,
} from './musicOnPhoneLines.Schema';

function MusicOnPhoneLinesComponent(): ReactElement {
  const licenseCode = LicenseTypes.MusicOnPhoneLines;
  const { values, setField, getError, costCalculated, showErrors } = useLicenseBusiness(licenseCode, {
    schema: musicOnPhoneLinesSchema,
    defaults: createMusicOnPhoneLinesDefaults,
  });

  const t = useTranslations(MUSIC_ON_PHONE_LINES_CONTENT_PATH);

  return (
    <>
      <NumberField
        label={t('numberOfPhoneLines.label')}
        name="numberOfPhoneLines"
        placeholder={t('numberOfPhoneLines.placeholder')}
        required
        disabled={costCalculated}
        value={values.numberOfPhoneLines}
        onChange={e => setField('numberOfPhoneLines', parseInt(e.target.value))}
        error={showErrors ? getError('numberOfPhoneLines') : undefined}
        validated={!!values.numberOfPhoneLines && !getError('numberOfPhoneLines')}
        min={1}
        sign="positive-only"
        styleVariant="border"
      />
    </>
  );
}

export default MusicOnPhoneLinesComponent;
